<template>
  <div class="sort">
    <div class="menu">
      <div class="menu-inner">
        <form ref="form">
          <ul class="list">
            <li class="item" v-for="radio in radios" :key="radio.scid">
              <label class="radio">
                <input
                  class="radio-input"
                  type="radio"
                  name="sort"
                  v-model="radioValue"
                  :value="radio.value"
                  @click="handleRadioClick(radio.scid)"
                />
                <div class="radio-text">{{ radio.label }}</div>
              </label>
            </li>
          </ul>
        </form>
        <button class="sort-button" @click="handleSortClicked">
          <span class="button-inner">並び替え</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { SORT_TYPE } from "../../../config/SORT_TYPE";
import { adobeClickEvent } from "../../../modules/analytics";

const RADIO_ARRAY = [
  {
    value: SORT_TYPE.priceAscending,
    label: "価格が安い順",
    scid: "kakaku_low",
  },
  {
    value: SORT_TYPE.priceDescending,
    label: "価格が高い順",
    scid: "kakaku_high",
  },
  {
    value: SORT_TYPE.reviewDescending,
    label: "レビューの評価が高い順",
    scid: "evaluation_high",
  },
  {
    value: SORT_TYPE.reviewAscending,
    label: "レビューの評価が低い順",
    scid: "evaluation_low",
  },
  {
    value: SORT_TYPE.reviewNumDescending,
    label: "レビュー数が多い順",
    scid: "review_large",
  },
  {
    value: SORT_TYPE.reviewNumAscending,
    label: "レビュー数が少ない順",
    scid: "review_small",
  },
];

export default {
  name: "Sort",
  data() {
    return {
      radios: RADIO_ARRAY,
      radioValue: "",
    };
  },
  props: {
    defaultSortType: {
      type: String,
      default: SORT_TYPE.priceAscending,
    },
  },
  created() {
    this.radioValue = this.defaultSortType;
  },
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(`sort_${eventId}`, url);
    },
    handleRadioClick(eventId) {
      this.analyze(eventId);
    },
    handleSortClicked() {
      const form = this.$refs.form;
      const sortType = form.sort.value;
      this.analyze("confirm");
      this.$emit("clickSort", sortType);
    },
  },
};
</script>
<style lang="scss" scoped>
.sort {
  .menu {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.05);
    z-index: 2;
    top: 48px;
  }

  .menu-inner {
    padding: 15px 20px;
  }

  .item {
    & + .item {
      margin-top: 7px;
    }
  }

  .radio {
    width: 100%;
    position: relative;
    /* margin: 20px 20px 0 0; */

    .radio-input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;

      &:checked + .radio-text {
        &::after {
          $size: 9px;
          content: "";
          display: block;
          position: absolute;
          /* top: 50%; */
          left: 3px;
          width: $size;
          height: $size;
          background-color: $main-red;
          /* margin-top: -4px; */
          border-radius: 50%;
        }
      }
    }

    .radio-text {
      display: flex;
      position: relative;
      align-items: center;
      width: 100%;
      height: 100%;
      cursor: pointer;
      text-align: left;
      word-break: keep-all;

      &::before {
        $size: 15px;
        content: "";
        display: block;
        margin-right: 5px;
        width: $size;
        height: $size;
        border-radius: 50%;
        background-color: #fff;
        border: 1px solid #dddddd;
        flex-shrink: 0;
      }
    }
  }

  .sort-button {
    $radius: 30px;
    width: 100%;
    background: transparent;
    color: $main-red;
    border-radius: $radius;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 15px;
    cursor: pointer;
    overflow: hidden;
    transform: translate3d(0, 0, 0);
    transition: color 0.3s $easing-color;

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: $main-red;
      transform: translateY(101%);
      transition: transform 0.2s $easing-transition,
        border-radius 0.1s $easing-transition;
    }

    .button-inner {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1;
      border: 1px solid $main-red;
      border-radius: $radius;
      width: calc(100% - 2px);
      height: calc(35px - 2px);
    }

    @media (hover: hover) {
      &:hover {
        color: #fff;

        &::before {
          border-radius: $radius;
          transform: translateY(0);
        }
      }
    }
  }

  @include media() {
    .menu {
      border-radius: vw(10);
      box-shadow: 0 0 vw(10) vw(2) rgba(0, 0, 0, 0.05);
    }

    .menu-inner {
      padding: vw(10);
    }

    .item {
      & + .item {
        margin-top: vw(8);
      }
    }

    .sort-button {
      $radius: vw(30);
      width: 100%;
      /* height: vw(24); */
      margin-top: vw(10);
      font-size: vw(10);
      border-radius: $radius;

      .button-inner {
        height: calc(#{vw(24)} - 2px);
        border-radius: $radius;
      }

      @media (hover: hover) {
        &:hover {
          &::before {
            border-radius: $radius;
          }
        }
      }
    }

    .radio {
      .radio-input {
        &:checked + .radio-text {
          &::after {
            $size: vw(7);
            left: vw(3);
            top: vw(3);
            width: $size;
            height: $size;
          }
        }
      }

      .radio-text {
        align-items: flex-start;
        line-height: 1.2;
        font-size: vw(10);

        &::before {
          $size: vw(13);
          margin-right: vw(8);
          width: $size;
          height: $size;
          position: relative;
          top: 0;
        }
      }
    }
  }
}
</style>
